import { v4 as uuidv4 } from 'uuid'
import { Buffer } from 'buffer'

export const generateIcsUrl = (startDate: string, endDate: string, summary: string, location: string) => {
  const icsLocation = location
    .replaceAll('\\', '\\\\')
    .replaceAll(';', '\\;')
    .replaceAll(',', '\\,')
    .replaceAll('\n', '\\n')

  summary = summary.replaceAll('\\', '\\\\').replaceAll(';', '\\;').replaceAll(',', '\\,').replaceAll('\n', '\\n')

  // var calendarEntryData =
  //   'BEGIN:VCALENDAR\n' +
  //   'CALSCALE:GREGORIAN\n' +
  //   'METHOD:PUBLISH\n' +
  //   'PRODID:-//Careum//CH\n' +
  //   'VERSION:2.0\n' +
  //   'BEGIN:VTIMEZONE\n' +
  //   'TZID:Europe/Zurich\n' +
  //   'BEGIN:DAYLIGHT\n' +
  //   'TZNAME:CEST\n' +
  //   'TZOFFSETFROM:+0100\n' +
  //   'TZOFFSETTO:+0200\n' +
  //   'DTSTART:19700329T020000\n' +
  //   'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU\n' +
  //   'END:DAYLIGHT\n' +
  //   'BEGIN:STANDARD\n' +
  //   'TZNAME:CET\n' +
  //   'TZOFFSETFROM:+0200\n' +
  //   'TZOFFSETTO:+0100\n' +
  //   'DTSTART:19701025T030000\n' +
  //   'RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU\n' +
  //   'END:STANDARD\n' +
  //   'END:VTIMEZONE\n' +
  //   'BEGIN:VEVENT\n' +
  //   'UID:' +
  //   uuidv4() +
  //   '\n' +
  //   'DTSTAMP;VALUE=DATE-TIME:' +
  //   formatDate() +
  //   '\n' +
  //   'DTSTART;VALUE=DATE-TIME:' +
  //   formatDate(startDate) +
  //   '\n' +
  //   'DTEND;VALUE=DATE:' +
  //   formatDate(endDate) +
  //   '\n' +
  //   'SUMMARY:' +
  //   summary +
  //   '\n' +
  //   'LOCATION:' +
  //   icsLocation +
  //   '\n' +
  //   'END:VEVENT\n' +
  //   'END:VCALENDAR'

  const calendarData = `BEGIN:VCALENDAR
    CALSCALE:GREGORIAN
    METHOD:PUBLISH
    PRODID:-//Careum//CH
    VERSION:2.0
    BEGIN:VTIMEZONE
    TZID:Europe/Zurich
    BEGIN:DAYLIGHT
    TZNAME:CEST
    TZOFFSETFROM:+0100
    TZOFFSETTO:+0200
    DTSTART:19700329T020000
    RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU
    END:DAYLIGHT
    BEGIN:STANDARD
    TZNAME:CET
    TZOFFSETFROM:+0200
    TZOFFSETTO:+0100
    DTSTART:19701025T030000
    RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU
    END:STANDARD
    END:VTIMEZONE
    BEGIN:VEVENT
    UID:${uuidv4()}
    DTSTAMP;VALUE=DATE-TIME:${formatDate()}
    DTSTART;VALUE=DATE-TIME:${formatDate(startDate)}
    DTEND;VALUE=DATE: ${formatDate(endDate)}
    SUMMARY:${summary}
    LOCATION:${icsLocation}
    END:VEVENT
    END:VCALENDAR`.replace(/^ +/gm, '')

  return `data:text/calendar;charset=utf8;base64,${Buffer.from(calendarData).toString('base64')}`
}

const formatDate = (date?: string) => {
  const formattedDate = date
    ? date.replace(' UTC', 'Z').replace(' ', 'T')
    : new Date().toISOString().split('.')[0] + 'Z'

  return formattedDate.replaceAll('-', '').replaceAll(':', '')
}
